export { default } from "./AgentBoxContent";
